<div class="modal-header">
    <h3 class="modal-title" id="modal-title">Försörjningskälla: {{ forsorjningskallaAggregat.namn }}</h3>
    <button type="button" id="btnLreClose" class="btn-close" aria-describedby="redigera försörjningsrad" (click)="dismiss()"></button>
</div>

<div class="modal-footer">
    <rask-button aid="buttonFkAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
    <rask-button aid="buttonFkTabort" color="primary" negative (click)="remove()">Ta bort försörjningsrad</rask-button>
</div>
